import { ReactNode, useEffect, useState } from "react";
import ReactFocusLock from "react-focus-lock";
import { RemoveScroll } from "react-remove-scroll";

import { X } from "@hagerty/icons";

import styles from "./DialogV2.module.scss";

type DialogPropsV2 = {
  children: ReactNode;
  heading: string;
  message: string;
  showCloseButton?: boolean;
  delayPopup?: boolean;
  onDismiss?: () => void;
};

export const DialogV2 = ({
  children,
  heading,
  message,
  onDismiss,
  showCloseButton,
  delayPopup = false,
}: DialogPropsV2) => {
  const [visible, setVisible] = useState(!delayPopup);

  // Delay dialog from rendering without getting rid of the background overlay.
  // This is useful for transitioning from one dialog to another.
  useEffect(() => {
    setTimeout(() => {
      if (!visible) {
        setVisible(true);
      }
    }, 200);
  }, [setVisible]);

  return (
    <div className={styles.overlay} onClick={onDismiss}>
      <ReactFocusLock autoFocus returnFocus>
        <RemoveScroll>
          {visible && (
            <div
              aria-modal="true"
              role="dialog"
              tabIndex={-1}
              aria-label="dialog content"
              className={styles.dialog}
              onClick={(event) => {
                event.stopPropagation();
              }}
            >
              <div className={styles.body}>
                <div className={styles.heading}>{heading}</div>
                <div className={styles.message}>{message}</div>
                {children}
              </div>
              {showCloseButton && (
                <button
                  className={styles.closeButton}
                  type="button"
                  aria-label="close dialog"
                  onClick={onDismiss}
                >
                  <X focusable="false" aria-hidden="true" />
                </button>
              )}
            </div>
          )}
        </RemoveScroll>
      </ReactFocusLock>
    </div>
  );
};
